import { render, staticRenderFns } from "./comercial_cambios_identificacion.vue?vue&type=template&id=3ebc79fc&scoped=true&"
import script from "./comercial_cambios_identificacion.vue?vue&type=script&lang=js&"
export * from "./comercial_cambios_identificacion.vue?vue&type=script&lang=js&"
import style0 from "./comercial_cambios_identificacion.vue?vue&type=style&index=0&id=3ebc79fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebc79fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3ebc79fc', component.options)
    } else {
      api.reload('3ebc79fc', component.options)
    }
    module.hot.accept("./comercial_cambios_identificacion.vue?vue&type=template&id=3ebc79fc&scoped=true&", function () {
      api.rerender('3ebc79fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/Details/comercial_cambios_identificacion.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details/comercial_cambios_identificacion.vue
// module id = WvL/
// module chunks = 0